import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import { Profile } from "../../components/profile/Profile";
import { ProfileDetails } from "../../components/profile/ProfileDetails";
import { Divider } from "@mui/material";

const UserProfile = () => {
  return (
    <Box component={Paper} elevation={0}>
      <Box textAlign={"center"} px={3} py={2}>
        <Typography variant='body3'>Account</Typography>
      </Box>
      <Divider />
      <Grid container px={3} py={3} spacing={3}>
        <Grid item lg={4} md={6} xs={12}>
          <Profile />
        </Grid>
        <Grid item lg={8} md={6} xs={12}>
          <ProfileDetails />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserProfile;
